/**
 * Privacy notice ("Personvernerklæring") — a public, presentational page.
 *
 * Content is human-approved and rendered VERBATIM as semantic HTML (no
 * markdown). It fetches nothing and requires no auth: it is declared OUTSIDE
 * the `AuthGate` boundary in `App()` so it is reachable without logging in
 * (see App.tsx). Styled with the same design tokens as the recipe read view
 * (a centred reading column) for visual consistency with the rest of the app.
 */

import React from "react";
import { Link } from "react-router-dom";

export function PrivacyPage(): React.JSX.Element {
  return (
    <main className="app-main">
      <article className="privacy-page" data-testid="privacy-page">
        <Link to="/" className="btn btn-ghost" data-testid="privacy-back">
          ← Tilbake til deSjeff
        </Link>

        <header className="privacy-head">
          <h1>Personvernerklæring for deSjeff</h1>
          <p className="privacy-updated">Sist oppdatert 9. juli 2026</p>
        </header>

        <section>
          <h2>Behandlingsansvarlig</h2>
          <p>
            deSjeff drives av Øyvind Stavenes som privatperson. Kontakt: oyvind.stavenes@gmail.com.
          </p>
        </section>

        <section>
          <h2>Hva vi samler inn og hvorfor</h2>
          <ul>
            <li>
              <strong>Konto:</strong> navn og e-postadresse (via innloggingen) — for å identifisere
              deg og gi deg tilgang til din egen kokebok.
            </li>
            <li>
              <strong>Innhold du lager:</strong> oppskrifter, ingredienser, fremgangsmåte og bilder
              du legger inn.
            </li>
            <li>
              <strong>AI-bruk (Sjef-assistenten):</strong> når du bruker AI-søk, sendes søketeksten
              din og relevant oppskriftsinnhold til Google (Gemini) for å gi deg svar.
            </li>
          </ul>
        </section>

        <section>
          <h2>Hvor dataene lagres</h2>
          <p>
            Konto, oppskrifter og bilder lagres innenfor EU (database i Frankfurt, bilder i EU,
            innlogging i Stockholm).{" "}
            <strong>
              AI-funksjonen bruker Google (Gemini): innhold du sender i AI-søk kan behandles utenfor
              EU, og på gratisnivået kan Google bruke dataene til å forbedre sine tjenester.
            </strong>{" "}
            <strong>Ikke legg inn sensitive personopplysninger i AI-søk.</strong>
          </p>
        </section>

        <section>
          <h2>Databehandlere</h2>
          <p>
            Vi bruker Zitadel (innlogging), Neon (database), Cloudflare (bildelagring) og Google
            (AI). De behandler data kun på våre vegne.
          </p>
        </section>

        <section>
          <h2>Deling</h2>
          <p>
            Vi selger ikke dataene dine, driver ikke markedsføring, og deler ikke data med andre enn
            behandlerne nevnt over.
          </p>
        </section>

        <section>
          <h2>Informasjonskapsler og lokal lagring</h2>
          <p>
            Vi bruker kun det som trengs for innlogging, samt en lokal innstilling for hvilken
            kokebok du sist brukte. Ingen sporing eller analyse.
          </p>
        </section>

        <section>
          <h2>Dine rettigheter</h2>
          <p>
            Du har rett til innsyn, retting og sletting av dine data. I denne piloten: send en
            e-post til oyvind.stavenes@gmail.com, så sletter vi kontoen og innholdet ditt.
          </p>
        </section>

        <section>
          <h2>Forbehold (lukket pilot)</h2>
          <p>
            deSjeff er i en tidlig, lukket pilotfase. Tjenesten og denne erklæringen kan endres.
          </p>
        </section>
      </article>
    </main>
  );
}
